import { render, staticRenderFns } from "./feeDetailOwner.vue?vue&type=template&id=d19b3078"
import script from "./feeDetailOwner.vue?vue&type=script&lang=js"
export * from "./feeDetailOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports